import img1 from "../assets/todo.png";
import img2 from "../assets/weather.png";
import img3 from "../assets/Rock Scissor Paper.png";
import img4 from "../assets/notes.jpg";
import img5 from "../assets/hospital.png";
import img6 from "../assets/library.jpg";
import img7 from "../assets/address.png";
import img8 from "../assets/anpr.png";

const data = [
  {
    id: 1,
    image: img1,
    title: "Todo App Save, Your Task Locally.",
    github: "https://github.com/SanjitBaruwal/Todo-App",
    demo: "https://savetask.netlify.app/",
  },
  {
    id: 2,
    image: img2,
    title: "Weather App",
    github: "https://github.com/SanjitBaruwal/React_Weather?tab=readme-ov-file",
    demo: "#",
  },
  {
    id: 3,
    image: img3,
    title: "Rock Scissors Paper",
    github: "https://github.com/SanjitBaruwal/Rock_Scissors_Paper",
    demo: "https://rockscissorpep.netlify.app",
  },
  {
    id: 4,
    image: img4,
    title: "Keep Notes",
    github: "https://github.com/SanjitBaruwal/Keep_Note",
    demo: "https://keepnotes1.netlify.app",
  },
  {
    id: 5,
    image: img5,
    title: "Hospital Management System",
    github: "https://github.com/SanjitBaruwal/Hospital-Management-System",
    demo: "https://hospital-management-system-patient.vercel.app",
  },
  {
    id: 6,
    image: img6,
    title: "Library Management System",
    github: "https://github.com/SanjitBaruwal/Library-Management-System",
    demo: "#",
  },
  {
    id: 7,
    image: img7,
    title: "Nepal Address Api",
    github: "https://github.com/SanjitBaruwal/Nepal_Location_API",
    demo: "https://nepal-location-api-client.vercel.app",
  },
  {
    id: 8,
    image: img8,
    title: "Number Plate Detection System",
    github:
      "https://github.com/rajeevy397/Nepali_Vehicle_License_Plate_Detector_And_Reader_YOLOv8",
    demo: "#",
  },
];

export default data;
